/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Return_No_Stock_OutInputs */

const vi_error_return_no_stock_out = /** @type {(inputs: Error_Return_No_Stock_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn chưa có phiếu xuất kho nên không có hàng để nhập trả.`)
};

/**

* @param {Error_Return_No_Stock_OutInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_return_no_stock_out = /** @type {((inputs?: Error_Return_No_Stock_OutInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Return_No_Stock_OutInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_return_no_stock_out(inputs)
});